import React from 'react';
import { useTranslation } from 'react-i18next';
import { BaseButton } from '../../../BaseComponents';
import { useTheme } from '../../../theme';
const ErrorMessage = ({ error, buttonText, title }) => {
    const { t } = useTranslation('CompareFares');
    const { ErrorMessage: css } = useTheme('CompareFares');
    if (!error) {
        return null;
    }
    return (React.createElement("div", { className: css.errorWrapper },
        React.createElement("h6", { className: css.errorTitle }, title !== null && title !== void 0 ? title : t('Internal error')),
        React.createElement("p", { className: css.errorText }, error.message),
        React.createElement(BaseButton, { variant: "optionAction" }, buttonText !== null && buttonText !== void 0 ? buttonText : t('Label'))));
};
export default ErrorMessage;
